import {Entity} from '@s-ui/domain'

/**
 * @implements Entity
 */
export default class AuthorEntity extends Entity {}
